import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestAttachmentsGet = {
    path: "/attachments",
    method: RouteHttpVerb.GET
};
export { locationRestAttachmentsGet };
